/**
 * Post message manager
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Class = require('Class');

    module.exports = Class.create({

        handlers: {},

        initialize: function() {
            window.addEventListener('message', this._handleMessages.bind(this));
        },

        /**
         * Find necessary handler by `id` and send message to his window
         * @param {String} id - identifier, which created while add new handler
         * @param {*} message - any payload
         * @param {Boolean} [serialize=true] - specifies on necessity of serialize `message` with `JSON.stringify`
         * @return {undefined}
         */
        sendMessage: function(id, message, serialize) {
            var handler = this.handlers[id] || {};
            var source = handler.source;
            var targetOrigin = handler.origin;

            if (arguments.length === 2) {
                serialize = true;
            }

            message = serialize
                ? JSON.stringify(message)
                : message;

            if (source && targetOrigin) {
                source.postMessage(message, targetOrigin);
            }
        },

        /**
         * Add handler for communication with some window (iframe/popup) via post message API
         * @param {Object} handler
         * @param {Window} handler.source - reference on window object
         * @param {Function} handler.callback - callback for handle messages from `handler.source`
         * @param {String} [handler.origin='*'] - origin of `handler.source` if it is known
         * @param {Boolean} [handler.parse=false] - specifies on necessity of parse incoming message with `JSON.parse`
         * @return {String} - handler ID
         */
        addHandler: function(handler) {
            var id = _.uniqueId('postMsgHdr_');

            this.handlers[id] = {
                origin: handler.origin || '*',
                source: handler.source,
                callback: handler.callback,
                parse: handler.parse || false
            };

            return id;
        },

        /**
         * Remove handler
         * @param {String} id - identifier, which created while add new handler
         * @return {undefined}
         */
        removeHandler: function(id) {
            delete this.handlers[id];
        },

        _handleMessages: function(event) {
            var callback;
            var parseMessage;
            var data = event.data;

            _.find(this.handlers, function(handler) {
                if (handler.source === event.source) {
                    callback = handler.callback;
                    parseMessage = handler.parse;

                    // update handler with actual origin
                    handler.origin = event.origin;
                    return true;
                }
            });

            if (_.isFunction(callback)) {
                var message = parseMessage ? this._parseMessage(data) : data;

                if (message instanceof Error) {
                    return callback(data, message);
                }

                callback(message);
            }
        },

        _parseMessage: function(message) {
            try {
                return typeof message === 'string'
                    ? JSON.parse(message)
                    : message;

            } catch (e) {
                return e;
            }
        }

    });
});
